import { TICK_MS } from '../sim/constants';

/**
 * Converts variable frame deltas into whole fixed sim ticks (classic accumulator), plus an
 * interpolation factor for smooth rendering between the last two ticks.
 */
export class FixedStepper {
  private accumulated = 0;

  constructor(
    private readonly stepMs: number = TICK_MS,
    /** Cap per frame so a long stall (tab switch, GC) can't trigger a catch-up spiral. */
    private readonly maxStepsPerFrame: number = 8,
  ) {}

  /** Adds frame time and returns how many ticks to run now. */
  advance(deltaMs: number): number {
    if (!(deltaMs > 0)) return 0;
    this.accumulated += deltaMs;
    let steps = Math.floor(this.accumulated / this.stepMs);
    this.accumulated -= steps * this.stepMs;
    if (steps > this.maxStepsPerFrame) {
      steps = this.maxStepsPerFrame;
      this.accumulated = 0; // drop the backlog: the game briefly slows instead of jumping
    }
    return steps;
  }

  /** Progress toward the next tick in [0, 1), for interpolating positions. */
  get alpha(): number {
    return this.accumulated / this.stepMs;
  }

  reset(): void {
    this.accumulated = 0;
  }
}
